/**
 * Shared CLI utilities.
 */
import { consola } from 'consola'
import { getLoggerConfig, getPinoLogger, initLoggerService, setLoggerInstance } from '@kernel/logger/index.js'

/** Initialize logger (required before discoverPlugins and other logger-dependent operations) */
export function initCli(): void {
  const config = getLoggerConfig()
  // In CLI mode, pino must not emit structured JSON to stdout — use level:error
  // so only actual errors propagate (and won't mix with consola user output).
  initLoggerService({ ...config, level: 'error', sentry: undefined })
  setLoggerInstance(getPinoLogger())
}

/**
 * Error class for CLI user-facing errors (invalid args, missing config, etc.).
 * Handled by `handleCliError()` — prints message without stack trace.
 */
export class CliError extends Error {
  constructor(message: string, public hint?: string) {
    super(message)
    this.name = 'CliError'
  }
}

/**
 * Print a CliError nicely and exit, or re-throw unknown errors.
 * Use in catch blocks where CliError may bubble up from validation.
 */
export function handleCliError(err: unknown): never {
  if (err instanceof CliError) {
    consola.error(err.message)
    if (err.hint) consola.info(err.hint)
    process.exit(1)
  }
  throw err
}
